/* @ngInject */
const myPhone = () => {
  return {
    restrict: 'E',
    scope: {
      myPhone: '=',
      id: '@myId',
    },
    template: require('./myPhone.html'),

    /* @ngInject */
    controller: ($scope, utils) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myPhone



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/directives/myPhone.js